import { LENGTH_FORMAT } from '@/helpers/unit.ts';
import { getTolerance, isWithinTolerance } from './tolerance';
import { BagType } from './types';

export interface ValidationResult {
  incorrectMeasurement: boolean;
}

export function calculateResult(
  sellerValues: number[], // in display unit
  agentValues: number[], // in display unit
  bagType: BagType,
  displayUnit: LENGTH_FORMAT
): ValidationResult {
  if (sellerValues.length === 0 || agentValues.length === 0) {
    return { incorrectMeasurement: true };
  }

  // 1. sort both array
  sellerValues = sellerValues.sort((a, b) => a - b);
  agentValues = agentValues.sort((a, b) => a - b);
  // 2. get tolerance
  const maxAgentValue = Math.max(...agentValues);
  const tolerance = getTolerance(bagType, maxAgentValue, displayUnit);

  const matchedSellerIndices = new Set<number>();
  let okCount = 0;
  for (const agentValue of agentValues) {
    for (let i = 0; i < sellerValues.length; i++) {
      if (matchedSellerIndices.has(i)) continue;
      if (isWithinTolerance(sellerValues[i], agentValue, tolerance)) {
        okCount++;
        matchedSellerIndices.add(i);
        break;
      }
    }
  }
  const threshold = Math.ceil(sellerValues.length / 2);
  return { incorrectMeasurement: okCount < threshold };
}
